"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractDetailsUpdate = exports.ContractDetailsCreate = exports.ContractDetails = exports.ContractTermUnitLabels = exports.ContractTermUnit = exports.ContractTermUnits = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
exports.ContractTermUnits = ['day', 'week', 'month', 'year'];
exports.ContractTermUnit = typebox_1.Type.Union(exports.ContractTermUnits.map((unit) => typebox_1.Type.Literal(unit)));
exports.ContractTermUnitLabels = {
    day: 'Day',
    week: 'Week',
    month: 'Month',
    year: 'Year',
};
exports.ContractDetails = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    contractStartDate: typebox_1.Type.String({ format: 'date' }),
    contractTerm: typebox_1.Type.Integer({ minimum: 1 }),
    contractTermUnit: exports.ContractTermUnit,
    contractEndDate: typebox_1.Type.String({ format: 'date' }), // Computed
    active: typebox_1.Type.Boolean(),
    salesRepID: typebox_1.Type.String({ format: 'uuid' }),
    // internalNotes
    // serviceDays
    // Recurring Rate
    // Add to Invoice when
    // Subscription Name
    metadata: common_1.MetaData,
});
exports.ContractDetailsCreate = typebox_1.Type.Omit(exports.ContractDetails, ['id', 'contractEndDate', 'metadata']);
exports.ContractDetailsUpdate = typebox_1.Type.Partial(typebox_1.Type.Omit(exports.ContractDetails, ['id', 'contractEndDate', 'metadata']));
//# sourceMappingURL=ContractDetails.js.map